import { render, staticRenderFns } from "./commandeclient_direct_add.vue?vue&type=template&id=b06aa05e&scoped=true&"
import script from "./commandeclient_direct_add.vue?vue&type=script&lang=js&"
export * from "./commandeclient_direct_add.vue?vue&type=script&lang=js&"
import style0 from "./commandeclient_direct_add.vue?vue&type=style&index=0&id=b06aa05e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06aa05e",
  null
  
)

export default component.exports